import React, { useMemo } from "react";

// UX
import CardDoctorSkeleton from "./CardDoctorSkeleton";
import ItemNotFound from "./ItemNotFound";
import CardDoctorContent from "./CardDoctorContent";
import { SCLocationType } from "./SelectCenter";

// Interface
import { State } from "../MobSmartAppointmentInterface";
import { DoctorAppointmentActionType } from "./Types";
import { FormattedMessage } from "react-intl";

// Types
export type CardDoctorListProps = {
  // data
  items: any[];
  loading?: boolean;
  numberOfFilters?: number;
  // callback
  onSelect?: (selected: Record<string, any>) => any;
  onButtonAction?: (
    data: Record<string, any>,
    action: DoctorAppointmentActionType,
    loading: string
  ) => any;
} & Pick<State, "loadingStatus" | "textSearch">;

export type DLLocationType = {
  center?: Record<string, any>;
} & SCLocationType;

// Images
const IMAGES = {
  notfound: "/images/Appointment/no-information-search.png",
  notfoundFilter: "/images/Appointment/no-information-filter.png",
};

const CardDoctorList = (props: CardDoctorListProps) => {
  const items = useMemo(() => {
    const skeletons = Array(4)
      .fill("")
      .map((_, index) => ({ id: index } as any));

    return props.loading ? skeletons : props.items;
  }, [props.loading, props.items]);

  if (props.loading) {
    return (
      <>
        {items.map((item) => (
          <CardDoctorSkeleton key={"card-skeleton" + item.id} />
        ))}
      </>
    );
  } else if (items.length) {
    return (
      <>
        {items.map((item) => (
          <CardDoctorContent
            key={"card-doctor" + item.id}
            data={item}
            isMedProgram={item.isMedProgram}
            // CommonInterface
            loadingStatus={props.loadingStatus}
            // callback
            onSelect={props.onSelect}
            onButtonAction={props.onButtonAction}
          />
        ))}
      </>
    );
  } else {
    return (
      <div style={{ height: "100%" }}>
        {props.textSearch && (props.numberOfFilters || 0) < 1 ? (
          <ItemNotFound
            img={IMAGES.notfound}
            subTitle={
              <>
                <FormattedMessage
                    id="bplusClinicKey1229"
                    values={{
                      textSearch: props.textSearch,
                    }}
                  />
              </>
            }
            style={{ whiteSpace: "pre-line"}}
          />
        ) : (
          <ItemNotFound
            img={IMAGES.notfoundFilter}
            subTitle={
              <>
                <div style={{font:"18px bold", color:"#393939"}}>
                  <FormattedMessage id="bplusClinicKey1247"/>
                </div>
                <div><FormattedMessage id="bplusClinicKey1248"/></div>
              </>
            }
            style={{ whiteSpace: "pre-line"}}
          />
        )}
      </div>
    );
  }
};

export default React.memo(CardDoctorList);
